export const newVideoDraft = () => ({
  title: "", cast: "", city: "", location: "", shoot_date: null, runtime_minutes: null,
  edit_status: "pending", tags: [], tiers: [], visibility: [], is_studio: false,
  description: "", free_description: "", promo_note: "",
  cast_crm_ids: [], cameraman_crm_ids: [], producer_crm_ids: [],
  platform_status: {}, cta: { use_default: true }, production_checklist: {},
  linked_photos: [], linked_extra_video_ids: [], models: [], crew_other: [],
});

// Explicit allowlist matches VideoCreate. Never POST stale IDs or Mux state.
const FIELDS = [
  "title", "cast", "city", "location", "shoot_date", "runtime_minutes", "edit_status",
  "tags", "visibility", "is_studio", "description", "free_description", "promo_note",
  "cast_crm_ids", "cameraman_crm_ids", "producer_crm_ids", "director_crm_id",
  "studio_crm_id", "studio_name_cache", "studio_scene_url", "show_in_free_area",
  "platform_status", "cta", "production_checklist", "linked_photos",
  "linked_extra_video_ids", "models", "crew_other", "scene_photos",
  "onlyfans_vip_link", "onlyfans_free_link", "faphouse_link", "justforfans_link",
];
export function videoCreatePayload(draft) {
  const payload = Object.fromEntries(FIELDS.filter((field) => draft[field] !== undefined).map((field) => [field, draft[field]]));
  payload.title = String(draft.title || "").trim();
  payload.visibility = [...new Set([...(draft.visibility || []), ...(draft.tiers || []).map((tier) => tier === "basic" ? "members" : tier)])];
  if (payload.shoot_date === "") payload.shoot_date = null;
  if (payload.runtime_minutes === "") payload.runtime_minutes = null;
  return payload;
}
